<template>
    <div class="wrapper col">
        <div class="section">
            <SubmitButton
                @click="linkedin"
            >
                <LogoLinkedinIcon class="inline-icon"/><span>Sign {{signup ? 'Up' : 'In'}} with LinkedIn</span>
            </SubmitButton>
            <input class="text-input" v-model="email" placeholder="Email" v-on:keyup.enter="submit">
            <input class="text-input" type="password" v-model="password" placeholder="Password" v-on:keyup.enter="submit">
            <input class="text-input" type="password" v-model="password2" v-if="signup" placeholder="Repeat Password" v-on:keyup.enter="submit">
            <input class="text-input" v-model="first" v-if="signup" placeholder="First Name" v-on:keyup.enter="submit">
            <input class="text-input" v-model="last" v-if="signup" placeholder="Last Name" v-on:keyup.enter="submit">
            <SubmitButton
                @click="submit"
                :isLoading="loading"
                :text="buttonText"
            />
        </div>
        <h1 class="showHide">
            <span @click="$router.push({ name: 'Sign Up', params: { routeAfter: routeAfter }})" v-if="!signup">Sign Up</span>
            <span @click="$router.push({ name: 'Log In', params: { routeAfter: routeAfter }})" v-else>Log In</span>
        </h1>
    </div>
</template>

<script>
import LogoLinkedinIcon from 'vue-ionicons/dist/logo-linkedin.vue'

import { auth, rtdb } from '../../db'

const users = rtdb.ref('users')

export default {
    name: 'LogIn',
    components: {
        LogoLinkedinIcon
    },
    props: {
        routeAfter: {
            type: String,
            default: '/profile'
        }
    },
    data() {
        return {
            email: '',
            password: '',
            password2: '',
            first: '',
            last: '',
            loading: false,
        }
    },
    computed: {
        signup() {
            return this.$route.name == "Sign Up"
        },
        name() {
            if (this.first && this.last)
                return this.first + ' ' + this.last
            else
                return ''
        },
        buttonText() {
            if (this.signup)
                return 'Sign Up'
            else
                return 'Log In'
        }
    },
    methods: {
        submit() {
            if (this.signup) {
                this.signUp()
            }
            else {
                this.logIn()
            }
        },
        signUp() {
            if (!this.email || !this.password || !this.password2 || !this.name) {
                this.error('Don\'t forget to fill in all the fields!')
                return
            }
            if (this.password != this.password2) {
                this.error('Hey, make sure the passwords match!')
                return
            }
            this.loading = true
            auth.createUserWithEmailAndPassword(this.email, this.password)
                .then((data) => {
                    data.user.updateProfile({
                        displayName: this.name
                    }).catch(e => console.log(e.message))
                    users.child(data.user.uid).set({
                        first: this.first,
                        last: this.last,
                        email: this.email,
                        img: 'https://firebasestorage.googleapis.com/v0/b/one-expo.appspot.com/o/users%2Fuser.svg?alt=media&token=e4d595b3-3c3b-464e-88cb-d9238b8525d2',
                        uid: data.user.uid,
                        profiles: {},
                    }).catch(e => console.log(e.message))
                    auth.signInWithEmailAndPassword(this.email, this.password)
                        .catch(e => console.log(e.message))
                    this.$router.push(this.routeAfter)
                })
                .catch(e => {
                    if (e.code == 'auth/email-already-in-use') {
                        this.error('Hey, another account is already using that email!')
                    } else if (e.code == 'auth/invalid-email') {
                        this.error('That email doesn\'t look valid!')
                    } else if (e.code == 'auth/weak-password') {
                        this.error(e.message)
                    } else {
                        this.error(e.message)
                    }
                }).finally(() => this.loading = false)
        },
        logIn() {
            if (!this.email || !this.password) {
                this.error('Don\'t forget to fill in all the fields!')
                return
            }
            this.loading = true
            auth.signInWithEmailAndPassword(this.email, this.password)
                .then(() => {
                    this.$router.push(this.routeAfter)
                })
                .catch((e) => {
                    if (e.code == 'auth/user-disabled') {
                        this.error('Sorry, this account has been disabled. Contact us for help!') // TODO: Contact support email
                    } else if (e.code == 'auth/invalid-email') {
                        this.error('That email doesn\'t look valid!')
                    } else if (e.code == 'auth/user-not-found' || e.code == 'auth/wrong-password') {
                        this.error('We looked, but we couldn\'t find a user with that email and password.')
                    } else {
                        this.error(e.message)
                    }
                }
                ).finally(() => this.loading = false)
        },
        linkedin() {
            this.$router.push('/linkedin')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../interface.scss';

.inline-icon {
    position: relative;
    display: inline;
    top: 0.13em;
    padding-right: 0.5em;
}
</style>